import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { IVehiclePosition } from 'app/shared/model/vehicle-position.model';
import { getEntities as getVehiclePositions } from 'app/entities/vehicle-position/vehicle-position.reducer';
import { getEntity, updateEntity, createEntity, reset } from './fifth-wheel-history.reducer';
import { IFifthWheelHistory } from 'app/shared/model/fifth-wheel-history.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const FifthWheelHistoryUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const companies = useAppSelector(state => state.company.entities);
  const vehiclePositions = useAppSelector(state => state.vehiclePosition.entities);
  const fifthWheelHistoryEntity = useAppSelector(state => state.fifthWheelHistory.entity);
  const loading = useAppSelector(state => state.fifthWheelHistory.loading);
  const updating = useAppSelector(state => state.fifthWheelHistory.updating);
  const updateSuccess = useAppSelector(state => state.fifthWheelHistory.updateSuccess);

  const handleClose = () => {
    props.history.push('/fifth-wheel-history' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));
    dispatch(getCompanies({}));
    dispatch(getVehiclePositions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdStart = convertDateTimeToServer(values.createdStart);
    values.createdEnd = convertDateTimeToServer(values.createdEnd);

    const entity = {
      ...fifthWheelHistoryEntity,
      ...values,
      vehicle: truckImplements.find(it => it.id.toString() === values.vehicleId.toString()),
      trailer: truckImplements.find(it => it.id.toString() === values.trailerId.toString()),
      company: companies.find(it => it.id.toString() === values.companyId.toString()),
      positionStart: vehiclePositions.find(it => it.id.toString() === values.positionStartId.toString()),
      positionEnd: vehiclePositions.find(it => it.id.toString() === values.positionEndId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdStart: displayDefaultDateTime(),
          createdEnd: displayDefaultDateTime(),
        }
      : {
          ...fifthWheelHistoryEntity,
          createdStart: convertDateTimeFromServer(fifthWheelHistoryEntity.createdStart),
          createdEnd: convertDateTimeFromServer(fifthWheelHistoryEntity.createdEnd),
          vehicleId: fifthWheelHistoryEntity?.vehicle?.id,
          trailerId: fifthWheelHistoryEntity?.trailer?.id,
          companyId: fifthWheelHistoryEntity?.company?.id,
          positionStartId: fifthWheelHistoryEntity?.positionStart?.id,
          positionEndId: fifthWheelHistoryEntity?.positionEnd?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.fifthWheelHistory.home.createOrEditLabel" data-cy="FifthWheelHistoryCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.fifthWheelHistory.home.createOrEditLabel">Create or edit a FifthWheelHistory</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="fifth-wheel-history-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.fifthWheelHistory.createdStart')}
                id="fifth-wheel-history-createdStart"
                name="createdStart"
                data-cy="createdStart"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fleetSenseApp.fifthWheelHistory.createdEnd')}
                id="fifth-wheel-history-createdEnd"
                name="createdEnd"
                data-cy="createdEnd"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="fifth-wheel-history-vehicle"
                name="vehicleId"
                data-cy="vehicle"
                label={translate('fleetSenseApp.fifthWheelHistory.vehicle')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="fifth-wheel-history-trailer"
                name="trailerId"
                data-cy="trailer"
                label={translate('fleetSenseApp.fifthWheelHistory.trailer')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="fifth-wheel-history-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.fifthWheelHistory.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="fifth-wheel-history-positionStart"
                name="positionStartId"
                data-cy="positionStart"
                label={translate('fleetSenseApp.fifthWheelHistory.positionStart')}
                type="select"
              >
                <option value="" key="0" />
                {vehiclePositions
                  ? vehiclePositions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="fifth-wheel-history-positionEnd"
                name="positionEndId"
                data-cy="positionEnd"
                label={translate('fleetSenseApp.fifthWheelHistory.positionEnd')}
                type="select"
              >
                <option value="" key="0" />
                {vehiclePositions
                  ? vehiclePositions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/fifth-wheel-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FifthWheelHistoryUpdate;
